// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2HyHw","footer":"ModalError_footer__1JCmz"};